import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { IMealCreditFormFields } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { getExpenseSettingsSubheader } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/ExpenseSettingsRule/hooks/getExpenseSettingsSubheader';

export interface UseGetExpenseSettingsSubheaderProps {
  expenseCodesForLabel: string;
}

export interface UseGetExpenseSettingsSubheader {
  subheader: string;
}

export const useGetExpenseSettingsSubheader = ({
  expenseCodesForLabel,
}: UseGetExpenseSettingsSubheaderProps): UseGetExpenseSettingsSubheader => {
  const { watch } = useFormContext<IMealCreditFormFields>();
  const expenseCodes = watch('expenseCodes');
  const expenseComments = watch('expenseComments');
  const expenseReason = watch('expenseReason');
  const subheader = getExpenseSettingsSubheader({
    expenseCodes,
    expenseComments,
    expenseReason,
    expenseCodesForLabel,
  });

  return {
    subheader,
  };
};
